import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { UserInfoMapperSocketHandler } from '../../utils/UserInfoMapper';
import { IMessage } from '../../models';
import CustomChatSwitch from './components/CustomChatSwitch';
import CommonChat from './components/CommonChat';
import PrivateChat from './components/PrivateChat';
import { socketContextType } from 'index';
import SocketContext from 'socket-context';

export type ThreadType = 'class' | 'individual';

interface Participant {
  id: string;
  name: string;
  fullname?: string;
  profilePhoto?: string;
  lastMessage?: IMessage;
}

const ChatApplication: React.FC = () => {
  const [threadType, setThreadType] = useState<ThreadType>('class');
  const [openPrivateChat, setOpenPrivateChat] = useState<Participant | null>(null);
  const { settings } = useSelector((state: RootState) => state.live);
  const { user } = useSelector((state: RootState) => state.auth);
  const { error } = useSelector((state: RootState) => state.live.chats);
  const dispatch = useDispatch<AppDispatch>();
  const userInfoHandler = useRef<UserInfoMapperSocketHandler | null>(null);
  const socketList: socketContextType[] = useContext(SocketContext);
  const roomId = useSelector((state: RootState) => state.live.settings.roomId);

  return (
    <div className="flex flex-col h-screen bg-[#24272C]">
      {error && <div className="text-red-500 p-2 text-center">{error}</div>}
      <div className="z-10 sticky top-0 bg-[#24272C]">
        <CustomChatSwitch
          activeType={threadType}
          changeChatType={setThreadType}
          setOpenPrivateChat={setOpenPrivateChat}
        />
      </div>
      <div className="flex-1">
        {threadType === 'class' ? (
          <CommonChat activeChatScreen={threadType} />
        ) : (
          <PrivateChat
          // roomId={settings.roomId}
          // setOpenPrivateChat={setOpenPrivateChat}
          // openPrivateChat={openPrivateChat}
          />
        )}
      </div>
    </div>
  );
};

export default ChatApplication;